import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';

@Component({
  selector: 'app-p00037-card-electrolyseur-statut',
  templateUrl: './p00037-card-electrolyseur-statut.component.html',
  styleUrls: ['./p00037-card-electrolyseur-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00037CardElectrolyseurStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  buttons: TuileButtonProps[] = [
    {
      title: 'P00037.card.state.status.off',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
      status: 'inactive',
    },
    {
      title: 'P00037.card.state.status.on',
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
      status: 'active',
    },
    {
      title: 'P00037.card.state.status.on',
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
      status: 'active',
    },
  ];

  status = [
    {
      title: '',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
    },
    {
      title: '',
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
    },
    {
      title: 'P00037.dashboard.regulation.small',
      icon: 'fa-kit fa-picto-programme',
      color: 'color-orange',
    },
    {
      title: 'P00037.dashboard.horloge',
      icon: 'fa-kit fa-picto-horloge',
      color: 'color-orange',
    },
    {
      title: 'P00037.dashboard.boost',
      icon: 'fa-kit fa-picto-boost24',
      color: 'color-orange',
    },
    {
      title: '',
      icon: 'fa-kit',
      color: 'color-orange',
    },
  ];

  getStatus(mode: number) {
    return this.buttons[mode];
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getButtons(): TuileButtonProps[] {
    return this.status;
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.ELECTROLYSEUR_SALT,
      FunctionOnglet.CONTROL,
      this.translateService.instant('P00037.dashboard.electrolyseur'),
    );
  }
}
